/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_ResumeInputs */

const en_us2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const pt_br2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retomar`)
};

const es_419_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reanudar`)
};

const pt_pt2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retomar`)
};

const fr_fr2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre`)
};

const de_de2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortsetzen`)
};

const it_it2_workout_live_resume = /** @type {(inputs: Workout_Live_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riprendi`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Workout_Live_ResumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_resume = /** @type {((inputs?: Workout_Live_ResumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_ResumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_resume(inputs)
	if (locale === "es-419") return es_419_workout_live_resume(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_resume(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_resume(inputs)
	if (locale === "de-DE") return de_de2_workout_live_resume(inputs)
	if (locale === "it-IT") return it_it2_workout_live_resume(inputs)
	return en_us2_workout_live_resume(inputs)
});
export { workout_live_resume as "workout-live.resume" }